// extracted by mini-css-extract-plugin
export var fullWidthButton = "_101-0";
export var tagInputDisabled = "_101-1";